import { render } from "./Header.vue?vue&type=template&id=fdd75f50&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=fdd75f50&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-fdd75f50"

export default script